export const getOrgSlugs = () => ["test", "test2"];
